import gsap from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'
import Lenis from '@studio-freight/lenis'

gsap.registerPlugin(ScrollTrigger)

export let lenis
export let scrollToStart

export const initLenis = () => {
  lenis = new Lenis({
    duration: 1.4,
    smoothTouch: false,
    easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t))
  })

  window.lenis = lenis

  lenis.on('scroll', ScrollTrigger.update)

  gsap.ticker.lagSmoothing(0)
  gsap.ticker.add((time) => lenis.raf(time * 1000))

  function raf(time) {
    lenis.raf(time)
    requestAnimationFrame(raf)

    if (lenis.direction == 1 && lenis.scroll > 0) {
      document.body.dataset.scrollDirection = 'forwards'
    } else {
      document.body.dataset.scrollDirection = 'backwards'
    }

    if (lenis.scroll > 200) {
      document.documentElement.dataset.reduceHeader = true
    } else {
      document.documentElement.dataset.reduceHeader = false
    }

    if (lenis.scroll > window.innerHeight) {
      showCta()
    } else {
      hideCta()
    }

    gsap.to('.floating-cta svg', {
      duration: 0.2,
      rotate: `${lenis.scroll / 20}deg`,
      ease: 'linear'
    })
  }

  let ctaIsShowing = false

  function showCta() {
    if (!ctaIsShowing) {
      ctaIsShowing = true
      gsap.fromTo(
        '.floating-cta',
        {
          scale: 0,
          rotate: -270
        },
        {
          scale: 1,
          rotate: 0,
          duration: 0.75,
          ease: 'back.out(1.4)'
        }
      )
    }
  }

  function hideCta() {
    if (ctaIsShowing) {
      ctaIsShowing = false
      gsap.to('.floating-cta', {
        scale: 0,
        rotate: 0,
        duration: 0.75,
        ease: 'expo.out'
      })
    }
  }

  requestAnimationFrame(raf)
}

scrollToStart = () => {
  lenis.start()
  lenis.scrollTo(0, { immediate: true })
}

export const scrollTo = () => {

  const links = document.querySelectorAll('[data-scroll-to]')

  if (!links) return

  links.forEach(link => {
    link.addEventListener('click', (e) => {
      e.preventDefault()
      const target = link.getAttribute('data-scroll-to')
      const offset = link.getAttribute('data-scroll-offset')
      const targetEl = document.querySelector(target)
      lenis.scrollTo(targetEl, {
        duration: 1.5,
        offset: offset,
        easing: (x) => {
          return x < 0.5 ? 4 * x * x * x : 1 - Math.pow(-2 * x + 2, 3) / 2
        }
      })
    })
  })
}

export default () => {}
